export const corner_radius= {
  'rounded-sm': 2,
  rounded: 4,
  'rounded-md': 6,
  'rounded-lg': 8,
  'full': 9999,
} as const;

// Define the type for spacing
export const spacing = {
  1: 4,
  2: 8,
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  9: 36,
  10: 40,
  12: 48,
  14: 56,
  16: 64,
} as const;

export const screenSize = {
  xs: 360,
  sm: 480,
  md: 640,
  lg: 768,
  xl: 960,
  '2xl': 1024,
  '3xl': 1280,
  '4xl': 1440,
} as const;
